<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Corporation Tax Reference (UTR)</h1>
    <p>If your company is claiming back CIS deductions suffered, we’ll need your Corporation Tax Unique Taxpayer Reference (often called your Corporation Tax UTR or CT UTR).</p>
    <p>This is a 10-digit number HMRC uses to identify your company for Corporation Tax purposes. It’s usually found on letters from HMRC about your company tax return or Corporation Tax account.</p>
    </div>
    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
          <input 
            type="text" 
            id="coTaxReference" 
            name="coTaxReference" 
            placeholder="" 
            v-model="formData.coTaxReference" 
            required 
            maxlength="13"
            @input="formData.coTaxReference = formData.coTaxReference ? formData.coTaxReference.toUpperCase().slice(0, 13) : ''"
          />
      </form>
    </div>



</template>


<script setup>

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';

const error = ref([]);
const route = useRoute();
const taskId = route.params.taskId;

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];


  if (!props.formData.coTaxReference && !props.formData.coTaxReference) {
    error.value.push('Please provide your Corporation Tax Unique Taxpayer Reference.');
  }

  const coTaxRef = (props.formData.coTaxReference || '').replace(/\s+/g, '').toLowerCase();

  if (
    !/^(\d{10}|\d{13}|k\d{10,13}|\d{10,13}k)$/.test(coTaxRef)
  ) {
    error.value.push(
      'Please enter a valid Corporation Tax Reference.'
    );
  }

  if (error.value.length > 0) return false;


  return true;
}


import { putDataCollectionTask } from '@/services/implementationmanagement.api';
const executeStep = async () => {

  var payload = {
    version: 1,
    dataJson: JSON.stringify(props.formData),
    schemaName: "CompanyCisSubContractors",
    taskId: taskId,
    taskStatus: "SuccessfullyCompleted"
  }

  var response = await putDataCollectionTask(taskId, payload);

  if (response.status !== 200) {
    error.value = 'Error saving data. Please contact your Qtac account manager.';
    return false;
  }

  return true;
}



onMounted(() => {


});

defineExpose({ validateStep, executeStep });

</script>